import { createAction } from "@reduxjs/toolkit";

import type { FeatureFlagState } from "./types";

export const updateFeatureFlag = createAction<FeatureFlagState>("featureFlag/update");
